<template>
    <div v-if="Upto10" style="height:100%;width:100%;" class="layoutBG">
        <div style="background: #FFF;height:80px;width:100%;position: absolute;"></div>
        <p style="height:4px;width:100%;background: #062F8C;position: absolute;top:76px;"></p>
        <div class="banner" style="position: relative">
            <div class="logoArea">
                <p class="logo"></p>
                <p class="hotlineCall"></p>
            </div>

            <div class="loginArea">
                <div v-if="UserStatus" class="loginAreaDiv">
                    <div style="display: flex;flex-direction: row;margin-top:0.25rem;">
                        <p>欢迎&nbsp;&nbsp;</p>
                        <p style="color:red;max-width:200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 1.5rem;">{{UserName}}</p>
                    </div>
                    <p style="padding:0 5px;"></p>
                    <p @click="Exit" class="loginT">退出</p>
                </div>
                <div v-else class="loginAreaDiv">
                    <p @click="Login" class="loginP">登录</p>
                    <p style="padding:0 5px;"></p>
                    <p @click="Register" class="loginZ">注册</p>
                </div>
            </div>

            <div style="position: absolute;top:0;left:0;width:100%">
                <Carousel autoplay loop style="width:100%" dots="none" :autoplay-speed="10000" v-model="Carousel">
                    <CarouselItem>
                        <div class="demo-carousel swiperBG1"></div>
                    </CarouselItem>
                    <CarouselItem>
                        <div class="demo-carousel swiperBG2"></div>
                    </CarouselItem>
                    <CarouselItem>
                        <div class="demo-carousel swiperBG3"></div>
                    </CarouselItem>
                </Carousel>
            </div>
            <!--<div class="decTxt"></div>-->
            <ul class="bannerList">
                <li v-for="(item,index) in content" :key="index" class="hvr-float">
                    <router-link :to="item.path"  :class="{'active':index==ActiveClass}" @click.native="DoActive(item.path)">{{item.label}}</router-link>
                </li>
            </ul>
        </div>


        <div style="margin-top:20px;">
            <router-view />
        </div>

        <!--注册和登录的弹出层-->
        <Modal v-model="ShowModal" width="400" footer-hide :mask-closable="false" @on-cancel="CancelModal">
            <div v-if="ModalType=='Login'" class="modalDiv">
                <Login ref="Login"
                       :LoginMethod="LoginMethod"
                       @CancelModal="CancelModal"
                       @ChangeUserName="ChangeUserName"
                       @ShowWechatModal="ShowWechatModal"
                ></Login>

                <div class="otherWay">
                    <div style="display: flex;flex-direction: row;align-items: center">
                        <p>其他方式登录：</p>
                        <img :src="IconList.phone" @click="ChangeLoginMethod(1)" v-show="LoginMethod!=1" class="imgClass" />
                        <img :src="IconList.password" @click="ChangeLoginMethod(2)" v-show="LoginMethod!=2" class="imgClass" />
                        <!--<img :src="IconList.code" @click="ChangeLoginMethod(3)" v-show="LoginMethod!=3" class="imgClass" />-->
                        <img :src="IconList.zww" @click="ChangeRegisterMethod(100)" class="imgClass" style="height: 29px;"/>
                    </div>
                    <p>还没账号？<span class="modalSpan" @click="ModalType='Register'">立即注册</span></p>
                </div>
            </div>

            <div v-else-if="ModalType=='Register'" class="modalDiv">
                <Register  ref="Register"
                           :RegisterMethod="RegisterMethod"
                           @CancelModal="CancelModal"
                           @ChangeUserName="ChangeUserName"
                           @ShowWechatModal="ShowWechatModal"
                ></Register>

                <div class="otherWay">
                    <div style="display: flex;flex-direction: row;align-items: center">
                        <p>其他方式注册：</p>
                        <img :src="IconList.phone" @click="ChangeRegisterMethod(1)" v-show="RegisterMethod!=1" class="imgClass" />
                        <img :src="IconList.code" @click="ChangeRegisterMethod(2)" v-show="RegisterMethod!=2" class="imgClass" />
                        <img :src="IconList.zww" @click="ChangeRegisterMethod(100)" class="imgClass" style="height: 29px;"/>
                    </div>
                    <p>已有账号？<span class="modalSpan" @click="ModalType='Login'">立即登录</span></p>
                </div>
            </div>
        </Modal>

        <Modal v-model="FollowWechat" title="欢迎关注微信公众号" footer-hide>
            <div class="wechatQRcode"></div>
        </Modal>

        <!--<div class="circle_small"></div>-->
        <!--<div class="circle_middle"></div>-->
        <!--<div class="circle_big"></div>-->
        <div class="driveLine"></div>

        <!--防冻提醒-->
        <!--<div class="fangDongTiXing" @click="FangDongTX=true"></div>-->
        <!--<div class="fangDongTiXing_Left" @click="FangDongTX=true"></div>-->
        <Modal v-model="FangDongTX" title="防冻温馨提示" footer-hide>
            <div class="FDTX"></div>
        </Modal>
    </div>
</template>

<script>
    import {getBrowserInfo} from '@/js/browser.js'
    import Register from "../../views/Register";
    import Login from "../../views/Login";
    import { Carousel,CarouselItem } from 'view-design';
    export default {
        name: "BaseLayout",
        components:{
            Register,
            Login,
            Carousel,
            CarouselItem
        },
        data(){
            return {
                Upto10:true,
                UserStatus:false,//用户登录状态
                UserName:"",
                content:[
                    {path:'PersonalBusinessList',label:'居民业务'},
                    {path:'CompanyBusinessList',label:'单位业务'},
                    {path:'AuthenticationList',label:'身份认证'},
                    {path:'CidList',label:'户号查询'},
                    {path:'BillPaymentList',label:'账单缴费'},
                    {path:'ProgressSearchList',label:'进度查询'},
                    {path:'ComplaintList',label:'报修及投诉'},
                    {path:'AccountManagementList',label:'账号管理'},
                    {path:'PublicAnnouncementList',label:'通知公告'},
                    {path:'SalesNetworkList',label:'营业网点'},
                    {path:'OperationManualList',label:'操作手册'}
                ],
                LoginMethod:1,//登录方式
                RegisterMethod:1,//注册方式
                ModalType:"Login",
                ShowModal:false,
                IconList:{
                    code:require('../../assets/Icon/code_register.png'),
                    phone:require('../../assets/Icon/phone_register.png'),
                    password:require('../../assets/Icon/password_login.png'),
                    zww:require('../../assets/Icon/zww.png'),
                },
                FollowWechat:false,
                Carousel:0,
                // SwiperHeight:{height:window.innerHeight*0.65+"px"}
                FangDongTX:false
            }
        },
        watch:{
            $route: {
                handler(to) {
                    //console.log(to)
                    if (to.path == '/PersonalBusinessList') {
                        if(localStorage.getItem('token')){
                            return false;
                        }else if (to.query.Token) {
                            this.$refs['Login'].Login('UnionId',to.query.Token)
                        }else if(to.query.Token==""){
                            this.$store.commit("CanShowModal",true);
                            this.$store.commit("ChangeUserName","");
                            this.$store.commit("ChangeBaseLayoutActive","PersonalBusinessList");
                            this.$Message.warning("请先注册或登录");
                        }
                    }
                },
            },
            CurrentUserStatus: {
                handler(newVal) {
                    // console.log(newVal)
                    if(newVal==""&&!localStorage.getItem("token")){
                        this.UserStatus=false;
                    }
                },
                deep: true,
                immediate: true
            },
            ShowModalStatus:{
                handler(newVal) {
                    if(newVal){
                        this.ShowModal=newVal;
                    }
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            ActiveClass() {
                return this.$store.state.ChangeBaseLayoutActive.CurrentActive;
            },
            CurrentUserStatus(){
                return this.$store.state.ChangeUserName.UserName;
            },
            ShowModalStatus(){
                return this.$store.state.CanShowModal.ModalStatus;
            }
        },
        created(){
            this.browserVersion();//检查浏览器
            //this.$router.push(window.location.pathname);//默认路由个人业务
            this.GetTicket();//判断是否政务网过来
        },
        mounted(){
            this.LoginStatus();//判断登录状态
            //this.GetSatisfactionData();
        },
        methods:{
            getQueryVariable(variable) {
              // 从?开始获取后面的所有数据
              var query = window.location.search.substring(1);
              // 从字符串&开始分隔成数组split
              var vars = query.split("&");
              // 遍历该数组
              for (var i = 0; i < vars.length; i++) {
                // 从等号部分分割成字符
                var pair = vars[i].split("=");
                // 如果第一个元素等于 传进来的参的话 就输出第二个元素
                if (pair[0] == variable) {
                  return pair[1];
                }
              }
              return (false);
            },
            browserVersion(){ //浏览器版本升级建议
                let browser = getBrowserInfo();//取到完整信息
                let b_name = (browser + "").replace(/[0-9./]/ig, "");//根据正则将所有数字、‘.’‘/’全部去掉，剩下浏览器名
                let b_version = Number((browser + "").replace(/[a-z]|[A-Z]|[/]/ig, ""));//根据正则将所有非数字全部去掉，剩下版本
                if(b_name=="IE"){
                    if(b_version<10){
                        this.$Message.warning({content: '为了更好的使用体验，请将您的IE升级至IE10以上', duration: 0});//error页
                        this.Upto10=false;
                    }
                }
            },
            LoginStatus(){
                let _UserName=localStorage.getItem("S_UserFlag");
                let _G_Roles=localStorage.getItem("G_Roles");
                if(_UserName&&_G_Roles){
                    this.UserName=_UserName?_UserName:"";
                    this.UserStatus=true;
                }else if(!_UserName&&_G_Roles){
                    this.UserName="";
                    this.UserStatus=true;
                }else{
                  this.UserName="";
                  this.UserStatus=false;
                }
            //   let _UserName=localStorage.getItem("S_UserFlag");
            //   let _UserPhone=localStorage.getItem("S_UserPhone");
            //   if(_UserName||_UserPhone){
            //       this.UserName=_UserName?_UserName:_UserPhone;
            //       this.UserStatus=true;
            //   }else{
            //       this.UserName="";
            //       this.UserStatus=false;
            //   }
            },
            Register(){
                this.ShowModal=true;
                this.ModalType='Register';
            },
            Login(){
                this.ShowModal=true;
                this.ModalType='Login';
            },
            Exit(){
                let that=this;
                that.InApi("api/redis/userlogin/UserLoginOut", "", "post").then(response => {
                    if(response){
                        localStorage.removeItem('G_Roles');
                        that.$store.commit("ChangeUserName","");
                        that.$store.commit("ChangeBaseLayoutActive","PersonalBusinessList");
                        that.UserStatus=false;
                        that.$router.push("PersonalBusinessList");
                        localStorage.removeItem('token');
                        localStorage.removeItem('S_UserFlag');
                        localStorage.removeItem('S_UserPhone');
                        localStorage.removeItem("CurrentActive");
                        localStorage.removeItem("BaseData");
                        localStorage.removeItem("ZWWToken");
                        that.CancelModal();
                    }
                });
            },
            DoActive(path){
                this.$store.commit("ChangeBaseLayoutActive",path);
            },
            ChangeLoginMethod(type){
                this.LoginMethod=type;
            },
            ChangeRegisterMethod(type){
                if(type==100){
                    window.location.href="https://sso.ahzwfw.gov.cn/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=394b3ba46eb34292af68ddf70beee8dc";
                    //window.location.href="http://60.166.52.177:8081/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=test";
                }else{
                    this.RegisterMethod=type;
                }
            },
            CancelModal(){
                this.ShowModal=false;
                this.LoginMethod=1;//登录方式
                this.RegisterMethod=1;//注册方式
                this.ModalType=='Login'?this.$refs['Login'].ResetFields():this.$refs['Register'].ResetFields();
                this.$store.commit("CanShowModal",false);
                this.$nextTick(function () {
                    this.ModalType="Login";
                });
            },
            ChangeUserName(userName){
                this.UserStatus=true;
                this.UserName=userName;
                this.$store.commit("ChangeUserName",userName)
            },
            ShowWechatModal(type){
                this.FollowWechat=type;
            },
            GetSatisfactionData() {
                let that = this;
                //20201203小高说增加一个调查问卷功能，游客也可以看见，优先弹窗后，用户点击问卷或者关闭问卷都记录localstorage中（一段时间不要弹出）
                if (localStorage.getItem("Satisfaction") == "0" || localStorage.getItem("Satisfaction") == undefined) {
                    that.$Modal.confirm({
                        title: "用户须知",
                        okText: "确认",
                        footerHide:true,
                        zIndex:9999,
                        content: "尊敬的用户：<br>" +
                            "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您好！感谢您使用马鞍山首创水务掌上营业厅。本网厅服务范围仅限马鞍山首创水务供水区域（花山区、雨山区），请知悉！",
                        onOk: () => {
                            localStorage.setItem("Satisfaction", "1");
                        },
                        onCancel: () => {
                            localStorage.setItem("Satisfaction", "1");
                        }
                    });
                }
            },
            GetTicket(){
              let _source=this.getQueryVariable('source');//从政务网过来的
              let _ticket=this.getQueryVariable('ticket');
              if(_source=="zww"&&_ticket&&_ticket!=""){
                this.LoginForZWW(_ticket);
              }else if(_source=="zww"){//如果_ticket是空或者不存在则跳转
                window.location.href="https://sso.ahzwfw.gov.cn/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=394b3ba46eb34292af68ddf70beee8dc";
                //window.location.href="http://60.166.52.177:8081/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=test";
              }
            },
            LoginForZWW (ticket) {
              let that=this;
              // let _hasToken=localStorage.getItem('token');//20220520张浩要求如果一个人登录多个zww账号跳转过来，直接顶掉之前那个所以不做此判断xiaohang
              // if(ticket&&_hasToken){return false;}
              that.InApi("api/WangTing/ZhengWuWang/LoginForZWW", {ticket:ticket},"post").then(response => {
                if(!response) return false;
                let res=JSON.parse(response);
                console.log(res)

                that.LoginTxt = "登录";
                if (res.ReturnCode == false) {
                  window.location.href="https://sso.ahzwfw.gov.cn/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=394b3ba46eb34292af68ddf70beee8dc";
                  //window.location.href="http://60.166.52.177:8081/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=test";
                  return false;
                }
                //console.log(res)
                localStorage.setItem('token', res.Token);
                localStorage.setItem('S_UserFlag',res.ReturnData[0].S_UserFlag);
                localStorage.setItem('S_OpenID',res.ReturnData[0].S_OpenID);
                localStorage.setItem('G_Roles',res.ReturnData[0].G_Roles);
                localStorage.setItem('S_UserPhone',res.ReturnData[0].S_UserPhone);
                localStorage.setItem('ZWWToken',res.LoginToken);
                that.ChangeUserName(res.ReturnData[0].S_UserFlag);
                that.CancelModal();
                //如果没有openid则跳关注
                if(res.ReturnData[0].S_OpenID==""||res.ReturnData[0].S_OpenID==null){
                  that.FollowWechat=true;
                  window.location.href="https://wt.maswater.cn/wangting";//刷新页面以防zww的链接反复调用刷新
                  return false;
                }
                //曾经微信公众号注册过但没完善信息的跳转
                if(!res.ReturnData[0].S_UserFlag){
                  that.$router.push({path: 'AccountManagementList',query:{TabName:"addUserInfo"}});
                  that.$store.commit("ChangeBaseLayoutActive","AccountManagementList");
                }else if(!res.ReturnData[0].S_UserPhone){
                  that.$router.push({path: 'AccountManagementList',query:{TabName:"changePhoneNumber"}});
                  that.$store.commit("ChangeBaseLayoutActive","AccountManagementList");
                }else{
                  window.location.href="https://wt.maswater.cn/wangting";//刷新页面以防zww的链接反复调用刷新
                  that.LocalStorage();//字典类的放storage里,如果有
                }
              });
            },
            GoToZWW(){
              window.location.href="https://sso.ahzwfw.gov.cn/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=394b3ba46eb34292af68ddf70beee8dc";
              //window.location.href="http://60.166.52.177:8081/uccp-server/login?service=https://wt.maswater.cn/wangting?source=zww&appCode=test";
            }
        }
    }
</script>

<style scoped>
.wechatQRcode{width:100%;height:250px;background: url("../../assets/Img/followMe.jpg") center no-repeat;background-size: contain}
.layoutBG{background-size:100% 100%;background-color: #F6F6F6;}
.banner{height:60%;width:100%;background-size:100% 80%;padding-top:40px;display: flex;flex-direction: row;justify-content: space-between}
.logoArea{flex:1;margin-left:12%;margin-top:-45px;display: flex;flex-direction: row}
.logo{width:320px;height:80px;background: url("../../assets/Img/PChome/logo_2.png") left no-repeat;background-size:contain;}
.bannerList{position:absolute;left:15%;height:5rem;line-height:5rem;display: flex;flex-direction: row;width:70%;background: #FFF;box-shadow: 0 5px 5px #ccc;border-radius: 10px;padding:0 1rem;}
    .bannerList>li{flex:1;text-align: center;}
    .bannerList>li a{color:#222;font-size: 1.15rem;padding:0.5rem 1rem;}
    .bannerList .active{color:#FFF;background: #022F8C;border-radius:5px;}
.loginArea{position:absolute;right:15%;top:5px;width:500px;display: flex;flex-direction: row;justify-content:flex-end;color:#FFF;z-index: 999}
.loginAreaDiv{display: flex;flex-direction: row;justify-content:flex-end;color:#FFF;position: absolute;right:30px;top:20px;}
.loginAreaDiv>p{height:26px;line-height: 24px;}
.modalDiv{padding:2rem 0}
.otherWay{display: flex;flex-direction: row;justify-content: space-between}
.modalSpan{border-bottom: 1px solid;font-size: 1.2rem;}
    .modalSpan:hover{color:#2d8cf0;cursor: pointer}
.loginP{width:70px;height:26px;border:1px solid #062F8C;border-radius: 13px;text-align: center;color:#333;transition:all 0.2s linear 0s; }
.loginP:hover{cursor: pointer;border-color:#F9703A;color:#F9703A}
.loginZ{width:70px;height:26px;border:1px solid #062F8C;border-radius: 13px;text-align: center;background-color: #062F8C;transition:all 0.2s linear 0s;}
.loginZ:hover{cursor: pointer;background-color: #F9703A;color:#FFF;border-color:#F9703A}
.loginT{color:#F9703A;width:70px;height:26px;border:1px solid #F9703A;border-radius: 13px;text-align: center;transition:all 0.2s linear 0s;}
.loginT:hover{cursor: pointer;background-color: #F9703A;color:#FFF}
.imgClass{cursor: pointer;padding-right:5px;}
    .decTxt{height:100px;width:400px;position: absolute;top:150px;left: 20%;color:#FFF;font-size:20px;letter-spacing: 3px;background: url("../../assets/Img/top_title.png") no-repeat;background-size: contain;}
    .bottomDesc{position: absolute;top:6rem;right:8rem;border:2px solid #23C2FF;padding:1.2rem 0.5rem;border-radius: 10px;background-color: #CCF1FF;display: flex;flex-direction: column;align-items: center}
    .downloadDescIcon{width:2.5rem;height:2.5rem;background: url("../../assets/Img/download.png") no-repeat;background-size: contain;}
.circle_small{width:23px;height:23px;position: absolute;right:120px;bottom:0%;background: url("../../assets/Img/circle_small.png") no-repeat;background-size: contain;}
.circle_middle{width:50px;height:50px;position: absolute;left:50px;bottom:20%;background: url("../../assets/Img/circle_middle.png") no-repeat;background-size: contain;}
.circle_big{width:60px;height:60px;position: absolute;right:40px;top:70%;background: url("../../assets/Img/circle_big.png") no-repeat;background-size: contain;}
    .driveLine{height:1px;width:100%;background-color: rgba(255,255,255,0.7);position: absolute;top:70px;left:0;}
    .demo-carousel{width:100%;background-size:100% 80%}
.swiperBG1{background:url("../../assets/Img/PChome/pcbanner1.png") 0 80px no-repeat;}
.swiperBG2{background:url("../../assets/Img/PChome/bgcmans.jpg") 0 80px no-repeat;}
.swiperBG3{background:url("../../assets/Img/PChome/pcbanner3.png") 0 80px no-repeat;}
.hotlineCall{width:140px;height:90px;background: url("../../assets/Img/PChome/hotlineCall.png") left no-repeat;background-size:contain;margin-left:2rem;}
/*.fangDongTiXing{position: fixed;right:0;top:55%;width:14rem;height:20rem;background: url("../../assets/Img/PChome/wxts.jpg") no-repeat;background-size:contain;cursor: pointer}*/
.FDTX{width: 420px;height: 600px;background: url("../../assets/Img/PChome/fdtx.jpg") no-repeat;background-size:100% 100%;margin:0 auto;}
.fangDongTiXing_Left{position: fixed;left:0;top:40%;width:220px;height:400px;background: url("../../assets/Img/PChome/wxts.jpg") no-repeat;background-size:contain;cursor: pointer}

</style>